import { render, staticRenderFns } from "./dialog_sale_shelf_channel.vue?vue&type=template&id=3ac09b75&scoped=true"
import script from "./dialog_sale_shelf_channel.vue?vue&type=script&lang=js"
export * from "./dialog_sale_shelf_channel.vue?vue&type=script&lang=js"
import style0 from "./dialog_sale_shelf_channel.vue?vue&type=style&index=0&id=3ac09b75&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac09b75",
  null
  
)

export default component.exports